import { useWhiteLabelStore } from '@/stores/white-label/WhiteLabelStore';
import { sharedRoutes } from '@/shared-routes';
import type { NavigationGuardNext, RouteLocation } from 'vue-router';
import { getActivationService } from '@arcual/lib-app-platform';

export const checkViewingRoomExists = async (
  to: RouteLocation,
  _from: RouteLocation,
  next: NavigationGuardNext
) => {
  const slug = to.params.slug as string;
  const whiteLabelStore = useWhiteLabelStore();

  if (!whiteLabelStore.activation) {
    await whiteLabelStore.setWhiteLabel();
  }

  if (!whiteLabelStore.activation) {
    return next({ path: sharedRoutes.NOT_FOUND });
  }

  await getActivationService()
    .getPublicActivationViewingRooms(whiteLabelStore.activationId, { searchOnValue: slug })
    .then((response) => {
      if (!response || !response.items || response.items.length === 0) {
        return next({ path: sharedRoutes.NOT_FOUND });
      }

      const [viewingRoom] = response.items.filter(item => item.subdomain === slug);
      if (!viewingRoom) {
        return next({ path: sharedRoutes.NOT_FOUND });
      }
      else {
        whiteLabelStore.setWhiteLabelFromViewingRoom(viewingRoom);
        return next();
      }
    })
    .catch(() => {
      return next({ path: sharedRoutes.NOT_FOUND });
    });
};
